const HomeIcon = ({size}) => {
    return(
        <svg role="img" height="24" width="24" className="Svg-sc-1bi12j5-0 hDgDGI home-icon" viewBox="0 0 24 24">
            <path fill="currentColor" d="M9 14h6v7h5V7.8l-8-4.6-8 4.6V21h5v-7zm1 8H3V7.2L12 2l9 5.2V22h-7v-7h-4v7z">
            </path>
        </svg>
    )
}
const SearchIcon = ({size}) => {
    return(
        <svg role="img" height="24" width="24" className="Svg-sc-1bi12j5-0 hDgDGI search-icon" viewBox="0 0 24 24">
            <path fill="currentColor" d="M16.387 16.623A8.47 8.47 0 0019 10.5a8.5 8.5 0 10-8.5 8.5 8.454 8.454 0 005.125-1.73l4.401 5.153.76-.649-4.399-5.151zM10.5 18C6.364 18 3 14.636 3 10.5S6.364 3 10.5 3 18 6.364 18 10.5 14.636 18 10.5 18z">
            </path>
        </svg>
    )
}
const CollectionIcon = ({size}) => {
    return(
        <svg role="img" height="24" width="24" className="Svg-sc-1bi12j5-0 hDgDGI collection-active-icon" viewBox="0 0 24 24">
            <path fill="currentColor" d="M14.617 3.893l-1.827.814 7.797 17.513 1.827-.813-7.797-17.514zM3 22h2V4H3v18zm5 0h2V4H8v18z">
            </path>
        </svg>
    )
}
const PlusIcon = ({size}) => {
    return(
        <svg role="img" height="12" width="12" aria-hidden="true" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path d="M14 7H9V2H7v5H2v2h5v5h2V9h5z"></path><path fill="none" d="M0 0h16v16H0z">
            </path>
        </svg>
    )
}
const HeartFilledIcon = ({size}) => {
    return(
        <svg role="img" height="12" width="12" aria-hidden="true" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="none" d="M0 0h16v16H0z" />
            <path fill="currentColor" d="M13.797 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253c-.77.77-1.194 1.794-1.194 2.883s.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195a4.052 4.052 0 001.195-2.883 4.057 4.057 0 00-1.196-2.883z" />
        </svg>
    )
}
const DownloadIcon = ({size}) => {
    return(
        <svg role="img" height="20" width="20" viewBox="0 0 24 24" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M11.5 0C5.149 0 0 5.148 0 11.5 0 17.851 5.149 23 11.5 23S23 17.851 23 11.5C23 5.148 17.851 0 11.5 0zm0 22C5.71 22 1 17.29 1 11.5S5.71 1 11.5 1 22 5.71 22 11.5 17.29 22 11.5 22zm.499-6.842V5h-1v10.149l-3.418-3.975-.758.652 4.678 5.44 4.694-5.439-.757-.653-3.439 3.984z" />
        </svg>
    )
}
const PrevIcon = ({size}) => {
    return(
        <svg role="img" focusable="false" height="22" width="22" viewBox="0 0 24 24" className="Svg-ytk21e-0 dMCjEC IYDlXmBmmUKHveMzIPCF">
            <polyline points="16 4 7 12 16 20" fill="none" stroke="currentColor" />
        </svg>
    )
}
const NextIcon = ({size}) => {
    return(
        <svg role="img" focusable="false" height="22" width="22" viewBox="0 0 24 24" className="Svg-ytk21e-0 dMCjEC IYDlXmBmmUKHveMzIPCF">
            <polyline points="8 4 17 12 8 20" fill="none" stroke="currentColor" />
        </svg>
    )
}
const DownDirIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" className="Svg-sc-1bi12j5-0 hDgDGI eAXFT6yvz37fvS1lmt6k" viewBox="0 0 16 16">
            <path fill="currentColor" d="M3 6l5 5.794L13 6z" />
        </svg>
    )
}
const ExternalIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill-rule="evenodd" fill="currentColor" d="M15 7V1H9v1h4.29L7.11 8.18l.71.71L14 2.71V7h1zM1 15h12V9h-1v5H2V4h5V3H1v12z" clip-rule="evenodd"/>
        </svg>
    )
}
const PauseIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="none" d="M0 0h16v16H0z" />
            <path d="M3 2h3v12H3zm7 0h3v12h-3z" />
        </svg>
    )
}
const PlayIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 24 24" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path d="M6 21l15.589-9L6 3z"/>
        </svg>
    )
}
const PlayerPrevIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M13 2.5L5 7.119V3H3v10h2V8.881l8 4.619z" />
        </svg>
    )
}
const PlayerNextIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M11 3v4.119L3 2.5v11l8-4.619V13h2V3z" />
        </svg>
    )
}
const ShuffleIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M4.5 6.8l.7-.8C4.1 4.7 2.5 4 .9 4v1c1.3 0 2.6.6 3.5 1.6l.1.2zm7.5 4.7c-1.2 0-2.3-.5-3.2-1.3l-.6.8c1 1 2.4 1.5 3.8 1.5V14l3.5-2-3.5-2v1.5zm0-6V7l3.5-2L12 3v1.5c-1.6 0-3.2.7-4.2 2l-3.4 3.9c-.9 1-2.2 1.6-3.5 1.6v1c1.6 0 3.2-.7 4.2-2l3.4-3.9c.9-1 2.2-1.6 3.5-1.6z" />
        </svg>
    )
}
const RepeatIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M5.5 5H10v1.5l3.5-2-3.5-2V4H5.5C3 4 1 6 1 8.5c0 .6.1 1.2.4 1.8l.9-.5C2.1 9.4 2 9 2 8.5 2 6.6 3.6 5 5.5 5zm9.1 1.7l-.9.5c.2.4.3.8.3 1.3 0 1.9-1.6 3.5-3.5 3.5H6v-1.5l-3.5 2 3.5 2V13h4.5C13 13 15 11 15 8.5c0-.6-.1-1.2-.4-1.8z" />
        </svg>
    )
}
const QueueIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M2 2v5l4.33-2.5L2 2zm0 12h14v-1H2v1zm0-4h14V9H2v1zm7-5v1h7V5H9z" />
        </svg>
    )
}
const DeviceIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" className="Svg-sc-1bi12j5-0 hDgDGI" aria-label="Connect to a device" viewBox="0 0 16 16">
            <path fill="currentColor" d="M0 3v8c0 .55.45 1 1 1h5v-1H1V3h5V2H1c-.55 0-1 .45-1 1zm3 11.5c0 .275.225.5.5.5H6v-1H3.5c-.275 0-.5.225-.5.5zM15 2H9c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 12H9V3h6v11zm-3-8a.75.75 0 100-1.5.75.75 0 000 1.5zm0 6a2 2 0 100-4 2 2 0 000 4zm0-3c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1z"/>
        </svg>
    )
}
const HeartIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill="currentColor" d="M13.764 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253A4.05 4.05 0 00.974 5.61c0 1.089.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195A4.052 4.052 0 0014.96 5.61a4.057 4.057 0 00-1.196-2.883zm-.722 5.098L8.58 13.048c-.307.36-.921.36-1.228 0L2.864 7.797a3.072 3.072 0 01-.905-2.187c0-.826.321-1.603.905-2.187a3.091 3.091 0 012.191-.913 3.05 3.05 0 011.957.709c.041.036.408.351.954.351.531 0 .906-.31.94-.34a3.075 3.075 0 014.161.192 3.1 3.1 0 01-.025 4.403z"/>
        </svg>
    )
}
const PictureInPictureIcon = ({size}) => {
    return(
        <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor" fill-rule="evenodd">
                <path d="M1 3v9h14V3H1zm0-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" fill-rule="nonzero"/>
                <path d="M10 8h4v3h-4z"/>
            </g>
        </svg>
    )
}
const VolumeMutedIcon = ({size}) => {
    return(
        <svg role="presentation" height="16" width="16" aria-label="Volume off" id="volume-icon" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill='currentColor' d="M0 5v6h2.804L8 14V2L2.804 5H0zm7-1.268v8.536L3.072 10H1V6h2.072L7 3.732zm8.623 2.121l-.707-.707-2.147 2.147-2.146-2.147-.707.707L12.062 8l-2.146 2.146.707.707 2.146-2.147 2.147 2.147.707-.707L13.477 8l2.146-2.147z"/>
        </svg>
    )
}
const VolumeLowIcon = ({size}) => {
    return(
        <svg role="presentation" height="16" width="16" aria-label="Volume low" id="volume-icon" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill='currentColor' d="M10.04 5.984l.658-.77q.548.548.858 1.278.31.73.31 1.54 0 .54-.144 1.055-.143.516-.4.957-.259.44-.624.805l-.658-.77q.825-.865.825-2.047 0-1.183-.825-2.048zM0 11.032v-6h2.802l5.198-3v12l-5.198-3H0zm7 1.27v-8.54l-3.929 2.27H1v4h2.071L7 12.302z"/>
        </svg>
    )
}
const VolumeNormalIcon = ({size}) => {
    return(
        <svg role="presentation" height="16" width="16" aria-label="Volume medium" id="volume-icon" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill='currentColor' d="M0 11.032v-6h2.802l5.198-3v12l-5.198-3H0zm7 1.27v-8.54l-3.929 2.27H1v4h2.071L7 12.302zm4.464-2.314q.401-.925.401-1.956 0-1.032-.4-1.957-.402-.924-1.124-1.623L11 3.69q.873.834 1.369 1.957.496 1.123.496 2.385 0 1.262-.496 2.385-.496 1.123-1.369 1.956l-.659-.762q.722-.698 1.123-1.623z" />
        </svg>
    )
}
const VolumeFullIcon = ({size}) => {
    return(
        <svg role="presentation" height="16" width="16" aria-label="Volume high" id="volume-icon" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill='currentColor' d="M12.945 1.379l-.652.763c1.577 1.462 2.57 3.544 2.57 5.858s-.994 4.396-2.57 5.858l.651.763a8.966 8.966 0 00.001-13.242zm-2.272 2.66l-.651.763a4.484 4.484 0 01-.001 6.397l.651.763c1.04-1 1.691-2.404 1.691-3.961s-.65-2.962-1.69-3.962zM0 5v6h2.804L8 14V2L2.804 5H0zm7-1.268v8.536L3.072 10H1V6h2.072L7 3.732z" />
        </svg>
    )
}
const LyricsIcon = ({size}) => {
    return(
        <svg role="img" height="16" width="16" viewBox="0 0 16 16" className="Svg-sc-1bi12j5-0 hDgDGI">
            <path fill='currentColor' d="M8.5 1A4.505 4.505 0 004 5.5c0 .731.191 1.411.502 2.022L1.99 13.163a1.307 1.307 0 00.541 1.666l.605.349a1.307 1.307 0 001.649-.283L9.009 9.95C11.248 9.692 13 7.807 13 5.5 13 3.019 10.981 1 8.5 1zM4.023 14.245a.307.307 0 01-.388.066l-.605-.349a.309.309 0 01-.128-.393l2.26-5.078A4.476 4.476 0 007.715 9.92l-3.692 4.325zM8.5 9C6.57 9 5 7.43 5 5.5S6.57 2 8.5 2 12 3.57 12 5.5 10.429 9 8.5 9z"/>
        </svg>
    )
}
const ArrowLeftIcon = ({size}) => {
    return(
        <svg height="16" role="img" width="16" viewBox="0 0 24 24" className="uH6KoDltK5GfeMZjR0rO">
            <polygon fill="currentColor" points="15.54,21.151 5.095,12.229 15.54,3.309 16.19,4.069 6.635,12.229 16.19,20.39 "></polygon>
        </svg>
    )
}
const MusicLibraryIcon = ({size}) => {
    return(
        <svg height="152" role="img" width="152" viewBox="-20 -25 100 100" className="UB3cP9wsqoAMAHaeBGDt cTYewTys80cdIcEk9dI2" aria-hidden="true" data-testid="card-image-fallback">
            <path fill='currentColor' d="M16 7.494v28.362A8.986 8.986 0 0 0 9 32.5c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9V9.113l30-6.378v27.031a8.983 8.983 0 0 0-7-3.356c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9s9-4.037 9-9V.266L16 7.494zM9 48.5c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7c0 3.859-3.141 7-7 7zm32-6.09c-3.86 0-7-3.14-7-7 0-3.859 3.14-7 7-7s7 3.141 7 7c0 3.861-3.141 7-7 7z"  fill-rule="evenodd"></path>
        </svg>
    )
}



const Icon = ({name, size = 24}) => {
    const icons = {
        home: HomeIcon,
        search: SearchIcon,
        collection: CollectionIcon,
        plus: PlusIcon,
        heartFilled: HeartFilledIcon,
        heart: HeartIcon,
        download: DownloadIcon,
        prev: PrevIcon,
        next: NextIcon,
        downDir: DownDirIcon,
        external: ExternalIcon,
        play: PlayIcon,
        pause: PauseIcon,
        playerPrev: PlayerPrevIcon,
        playerNext: PlayerNextIcon,
        repeat: RepeatIcon,
        shuffle: ShuffleIcon,
        queue: QueueIcon,
        pictureInPicture: PictureInPictureIcon,
        device: DeviceIcon,
        volumeMuted: VolumeMutedIcon,
        volumeLow:VolumeLowIcon,
        volumeNormal: VolumeNormalIcon,
        volumeFull: VolumeFullIcon, 
        lyrics: LyricsIcon,
        arrowLeft: ArrowLeftIcon,
        musicLibrary: MusicLibraryIcon
    }
    const Component = icons[name]
    return <Component size={size} />
}

export{
    Icon
}